import { can } from "@bt/domain";
import { useQuery } from "@tanstack/react-query";
import { createFileRoute } from "@tanstack/react-router";
import { useTranslation } from "react-i18next";
import { GarageRecoveryKeyCard } from "@/features/keys/keys";
import { Members } from "@/features/members/members";
import { SettingsPage } from "@/features/settings/section";
import { garage } from "@/lib/garage";
import { useTRPC } from "@/lib/trpc";

export const Route = createFileRoute("/settings/members")({
  component: MembersPage,
});

/**
 * Settings › Members: who belongs to this garage, where people have accounts; for garage admins
 * also the garage recovery key (ADR 0022), the last way into its data.
 */
function MembersPage() {
  const { t } = useTranslation();
  const trpc = useTRPC();
  const { data: access } = useQuery(trpc.garages.access.queryOptions());
  const manage = access?.kind === "member" && can(access, "garage.manage");
  return (
    <SettingsPage title={t("members.title")} description={t("members.body")}>
      <Members garageName={garage ?? ""} />
      {manage ? <GarageRecoveryKeyCard /> : null}
    </SettingsPage>
  );
}
